/**
 * References to documents generated and maintained by external services (ex. DMS).
 */
export enum ExternalDocumentReferenceType {
  DMS = 'DMS',
  SCALE_AI = 'SCALE_AI',
}
